import { moment } from "@msuite/utils/date";
import { Icon } from "../icons";
import { useTranslation } from "../localization";
import { TimelineLine } from "./timeline-line";
import { TimelineRow } from "./timeline-row";

/** Props Interface */
interface TimelineDateRowProps {
	withoutLine?: boolean;
	date: string;
}

export function TimelineDateRow({ withoutLine, date }: TimelineDateRowProps) {
	/** Hooks */
	const { language } = useTranslation();

	/** Render */
	return (
		<TimelineRow>
			<TimelineLine
				withoutLine={withoutLine}
				renderItemMarker={() => (
					<Icon
						name="Calendar"
						className="stroke-primary-500"
					/>
				)}
			/>
			<p
				className="mt-1 pb-4 font-medium text-sm"
				id={`timeline-section-${date}`}
			>
				{moment(date).locale(language).dateFormat()}
			</p>
		</TimelineRow>
	);
}
